.panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-5);
  text-align: center;
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-2xl);
}

.problem {
  margin: 0;
  max-width: 460px;
  font-size: var(--tuna-typography-body1-fontSize);
}

.privacy {
  margin: 0;
  max-width: 460px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.still {
  margin: 0;
  min-height: 1.5em;
  max-width: 460px;
  font-size: var(--tuna-typography-body2-fontSize);
  font-weight: 700;
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-2);
  align-items: center;
}
